var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "editor-component" },
    [
      _c(
        "TextareaComponent",
        _vm._g(
          _vm._b(
            {
              ref: "textarea",
              attrs: {
                pickerStyle: _vm.pickerStyle,
                text: _vm.textHtml,
                charactersLength: _vm.charactersLength,
                maxCharacters: _vm.maxCharacters,
                ShowCounterCharacters: _vm.ShowCounterCharacters,
                textInfoMaxCharacters: _vm.textInfoMaxCharacters,
                showOptionBold: _vm.showOptionBold,
                showOptionItalic: _vm.showOptionItalic,
                compactOption: _vm.compactOption,
                disableHashtag: !this.pagesSelected.find(
                  (p) =>
                    p.network == "instagram" &&
                    p.story_config &&
                    p.story_config.created
                ),
                disableMention: !this.pagesSelected.find(
                  (p) =>
                    [
                      "facebook",
                      "instagram",
                      "linkedin",
                      "twitter",
                      "bluesky",
                    ].includes(p.network) ||
                    (p.network == "tiktok" &&
                      p.story_config &&
                      p.story_config.created)
                ),
              },
              on: {
                newMention: _vm.newMention,
                editMention: _vm.editMention,
                newHashtag: _vm.newHashtag,
                change: _vm.changeText,
                updateMentionLabel: _vm.updateMentionLabel,
              },
            },
            "TextareaComponent",
            _vm.$attrs,
            false
          ),
          _vm.$listeners
        )
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }